// @flow
// $FlowFixMe
import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import type { ReportResponseProps } from 'types/reports'

import { DATE_CONSTANTS } from '@/domain/constants/date'
import { QUERIES } from '@/enums/queries'

import loadResourcesSettings from './services/loadResourcesSettings'

export const useLoadResourcesSettings = (
  id: string,
  options: any = {}
  // $FlowFixMe
): UseQueryResult<ReportResponseProps, Error> => {
  return useQuery({
    queryKey: [QUERIES.RESOURCES_SETTINGS, id],
    queryFn: () => loadResourcesSettings(id),
    staleTime: DATE_CONSTANTS.TIME_IN_MILLISECONDS.SECOND * 20,
    cacheTime: DATE_CONSTANTS.TIME_IN_MILLISECONDS.SECOND * 20,
    ...options,
  })
}

export const invalidateLoadResourcesSettings = (id: string) => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.RESOURCES_SETTINGS, id],
    exact: false,
  })
}
